import type {Job} from './model'
export type ProviderHealth={state:'healthy'|'cooldown'|'probe';reason:string|null;signal_excerpt:string|null;until:string|null;probe_job:string|null;blocked_count:number}
export const providerNames:Record<string,string>={codex:'קודקס',claude:'קלוד',model_he:'מודל עברית · RunPod',model_code:'מודל קוד · RunPod'}
export function waitingProvider(job:Job|undefined,health:Record<string,ProviderHealth>|undefined){
 if(!job||job.state!=='queued')return null
 const requested=job.agent_requested
 const provider=(job as Job&{waiting_provider?:string}).waiting_provider??(requested&&requested!=='auto'?requested:'codex')
 const status=health?.[provider]
 return status&&status.state!=='healthy'?{provider,...status}:null
}
